<template>
  <div>
    <nav class="
            navbar navbar-main navbar-expand-lg
            px-0
            mx-4
            shadow-none
            border-radius-xl
          " v-bind="$attrs" id="navbarBlur" data-scroll="true">
      <div class="px-3 py-1 container-fluid">
        <breadcrumbs :currentPage="currentRouteName" textWhite="text-white" />

        <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" id="navbar">
          <div class="pe-md-3 d-flex align-items-center ms-md-auto"></div>
          <ul class="navbar-nav justify-content-end">
            <li class="nav-item d-flex align-items-center text-white fs-6">
              <i class="fa fa-user me-sm-2"></i>
              <span @click="logout()" style="cursor: pointer">
                {{ currentUser }}
              </span>
            </li>
            <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
              <a href="#" @click="toggleSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
                <div class="sidenav-toggler-inner">
                  <i class="sidenav-toggler-line bg-white"></i>
                  <i class="sidenav-toggler-line bg-white"></i>
                  <i class="sidenav-toggler-line bg-white"></i>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import jwt_decode from "jwt-decode";
import { mapMutations, mapActions, mapGetters } from "vuex";
import swal from "sweetalert";

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    logout: () => {
      swal({
        icon:"warning",
        title: "Logout ?",
        buttons: {
          ya: "Ya",
          cancel: "Batalkan"
        }
      }).then(async (val) => {
        switch (val) {
          case "ya":
            localStorage.removeItem("user");
            localStorage.removeItem("group_data");
            location.reload();
            break;

          default:
            break;
        }
      })
    }
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    currentRouteName() {
      const path = this.$route.path;
      const pathing = path
        .split("/")
        .filter(function (e) {
          return e;
        })
        .join(" / ");
      return pathing;
    },
    currentUser() {
      if (localStorage.getItem("user")) {
        const decode = jwt_decode(localStorage.getItem("user"));
        return decode.name;
      } else {
        return "none";
      }
    },
  },
};
</script>
